// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__xaCxf","content":"container_content__2ZVwr"};